import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../config/authConfig';

const LoginPage = () => {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  
  // Check if user is already logged in
  useEffect(() => {
    const checkAuth = async () => {
      // Check if we have accounts from MSAL
      if (accounts && accounts.length > 0) {
        console.log("User already logged in, redirecting to dashboard");
        navigate('/dashboard', { replace: true });
        return;
      }
      
      // Check if we're in a post-login redirect scenario
      try {
        const response = await instance.handleRedirectPromise();
        if (response) {
          console.log("Login response received in LoginPage:", response);
          navigate('/dashboard', { replace: true });
        }
      } catch (error) {
        console.error("Error handling redirect in LoginPage:", error);
      }
    };
    
    checkAuth();
  }, [accounts, navigate, instance]);
  
  const handleLogin = async () => {
    try {
      setIsLoggingIn(true);
      
      // Check if running on mobile device
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      if (isMobile) {
        // For mobile, popup often works better than redirect
        const result = await instance.loginPopup(loginRequest);
        console.log("Login success via popup:", result);
        navigate('/dashboard', { replace: true });
      } else {
        // For desktop, use redirect flow
        await instance.loginRedirect(loginRequest);
      }
    } catch (error) {
      console.error('Login failed:', error);
      setIsLoggingIn(false);
    }
  };
  
  // If accounts exist, redirect to dashboard
  if (accounts && accounts.length > 0) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4 py-12 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            AWS EC2 Controller
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Sign in with your Office 365 account to access the dashboard
          </p>
        </div>
        <div className="mt-8 space-y-6">
          <button
            onClick={handleLogin}
            disabled={isLoggingIn}
            className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span className="absolute left-0 inset-y-0 flex items-center pl-3">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
              </svg>
            </span>
            {isLoggingIn ? 'Signing in...' : 'Sign in with Office 365'}
          </button>
        </div>
        <div className="mt-6">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-gray-100 text-gray-500">
                Secured by Microsoft Azure
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 